import * as dnsPacket from 'dnspacket-ts';

globalThis.Buffer = class { }; // aaaa

export async function query(question, endpoint) {
    const response = await fetch(`https://${endpoint}/dns-query`, {
        method: 'POST',
        headers: {
            'accept': 'application/dns-message',
            'content-type': 'application/dns-message',
        },
        body: dnsPacket.encode(question),
    });
    return dnsPacket.decode(await response.bytes());
}
